export const CART_DRAWER_TAG_NAME = "cart-drawer";
export const CART_ICON_BUBBLE_TAG_NAME = "cart-icon-bubble";
export const CART_ICON_BUBBLE_ID_SELECTOR = "#cart-icon-bubble";
export const SHOPIFY_SECTION_CLASS_SELECTOR = ".shopify-section";
export const EMPTY_CART_CLASSNAME = "is-empty";
export const CART_FOOTER_ID = "main-cart-footer";
export const JS_CONTENTS_SELECTOR = ".js-contents";
